import {FormControl} from '@angular/forms';

export class Member {
    id: string;
    name: string;
    // password: string;
    // email: string;
    // lang: string;
    // member_id: string;
    status: string;
    telephone: string;
    address: string;
  department_id: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string; 
  usermanager: string;
  branch_id: string;
  distribution_system: string;
  distribution_mechanism: string;
  manager_id: string;
  category_id: string;
  currency_id: string;
  city_id: string;
  process: string;
  actions: string;
  users: string;


    // manager: any;
    last_update_user:string;
    last_update_ip:string;
    on_behalf_of:string;
    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }

}



// WEBPACK FOOTER //
// ./src/app/views/setting/members/member.ts